import type { ErrorPageData, PageProps } from "@/types";
import React, { FC } from "react";
import { Link } from "../link";
import Image from "next/image";

export const Error: FC<PageProps<ErrorPageData>> = (props) => {
  return (
    <div className="errorPage">
      <div className="errorPage--inner">
        <div className="wrapper">
          <h1 className="errorPage--title">
            <span>404</span>
            <br />
            {props.data.title}
          </h1>
          <p className="errorPage--description">{props.data.description}</p>
          {props.data.backLink.buttonLink && (
            <Link
              href={props.data.backLink.buttonLink}
              theme="blue"
              fill="full"
              className="errorPage--backLink"
            >
              {props.data.backLink.buttonLabel}
            </Link>
          )}
        </div>
        <Image
          src="/images/spiral-2-white.webp"
          alt="Spiral"
          width={1195}
          height={1467}
          draggable={false}
          className="errorPage--spiral lg"
          sizes="(max-width: 1023px) 100vw, 1023px"
        />
        <Image
          src="/images/spiral.webp"
          alt="Spiral"
          width={1195}
          height={1467}
          draggable={false}
          className="errorPage--spiral sm"
          sizes="(max-width: 1023px) 100vw, 1023px"
        />
      </div>
    </div>
  );
};
